import type { IconProps } from './../../models/icon';

export function CashIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M15.4286 12.8571C19.6892 12.8571 23.1429 11.3221 23.1429 9.42857C23.1429 7.53502 19.6892 6 15.4286 6C11.1682 6 7.71436 7.53502 7.71436 9.42857C7.71436 11.3221 11.1682 12.8571 15.4286 12.8571Z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M8.72479 7.7308C8.67372 7.73125 8.62253 7.73147 8.57122 7.73147C4.31074 7.73147 0.856934 6.19645 0.856934 4.3029C0.856934 2.40935 4.31074 0.874329 8.57122 0.874329C12.8317 0.874329 16.2855 2.40935 16.2855 4.3029C16.2855 4.92059 15.918 5.50014 15.2748 6.00069C12.4685 6.02504 10.0295 6.7154 8.72479 7.7308Z"
          clipRule="evenodd"
        />
        <path
          fill={secondaryColor}
          d="M15.4286 12.8571C19.6892 12.8571 23.1429 11.3221 23.1429 9.42856V19.7143C23.1429 21.6 19.7144 23.1428 15.4286 23.1428C11.1429 23.1428 7.71436 21.6 7.71436 19.7143V9.42856C7.71436 11.3221 11.1682 12.8571 15.4286 12.8571Z"
        />
        <path
          fill={secondaryColor}
          d="M8.74726 7.73058C8.68873 7.73117 8.63005 7.73146 8.57122 7.73146C4.31074 7.73146 0.856934 6.19644 0.856934 4.30289V14.5886C0.856934 16.4743 4.28551 18.0172 8.57122 18.0172C12.8569 18.0172 16.2855 16.4743 16.2855 14.5886V12.8534C16.0041 12.8672 15.7181 12.8743 15.4284 12.8743C11.1679 12.8743 7.71408 11.3393 7.71408 9.44574C7.71408 8.82089 8.09017 8.23508 8.74726 7.73058Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M15.4286 12.8571C19.6892 12.8571 23.1429 11.3221 23.1429 9.42857C23.1429 7.53502 19.6892 6 15.4286 6C11.1682 6 7.71436 7.53502 7.71436 9.42857C7.71436 11.3221 11.1682 12.8571 15.4286 12.8571Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M7.71436 9.42856V19.7143C7.71436 21.6 11.1429 23.1428 15.4286 23.1428C19.7144 23.1428 23.1429 21.6 23.1429 19.7143V9.42856"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.1429 14.5714C23.1429 16.4572 19.7144 18 15.4286 18C11.1429 18 7.71436 16.4572 7.71436 14.5714"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M15.2569 2.58856C13.2538 1.35234 10.9221 0.754466 8.57122 0.874268C4.30265 0.874268 0.856934 2.41713 0.856934 4.30284C0.856934 5.31427 1.85122 6.22284 3.42836 6.87427"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M3.42836 17.16C1.85122 16.5086 0.856934 15.6 0.856934 14.5886V4.30289"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M3.42836 12.0172C1.85122 11.3658 0.856934 10.4572 0.856934 9.44577"
        />
      </g>
    </svg>
  );
}
